var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAirport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_781_11018)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 6.667h-2.205L8.964 1.042A2 2 0 007.208 0h-.121A1.753 1.753 0 005.4 2.24l1.285 4.427h-1.59a1.988 1.988 0 01-1.414-.586l-.944-.948A1.606 1.606 0 00.86 4.845a1.546 1.546 0 00-.778.948 1.683 1.683 0 00.152 1.31L1.31 8.987a3.341 3.341 0 002.894 1.68H6.68L5.567 13.63A1.753 1.753 0 007.207 16a1.982 1.982 0 001.738-1.009l2.698-4.324H14a2 2 0 100-4zM6.683 1.87a.42.42 0 01.404-.537h.12a.66.66 0 01.576.328l2.52 5.006h-2.23L6.683 1.87zM14 9.333h-2.727a.667.667 0 00-.566.314L7.793 14.32a.667.667 0 01-.585.348.419.419 0 01-.392-.567l1.45-3.867a.667.667 0 00-.625-.9H4.205a2 2 0 01-1.733-1.008l-1.08-1.884a.349.349 0 01-.03-.266.215.215 0 01.105-.141.277.277 0 01.325.045l.944.944A3.315 3.315 0 005.096 8H14a.667.667 0 110 1.333z",
    fill: "#5A6366"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_781_11018"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirport);
export default __webpack_public_path__ + "static/media/airport.8be906d3d371b1d0903263d415e1b92a.svg";
export { ForwardRef as ReactComponent };